import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

import { OnboardingLayout } from "./OnboardingLayout";
import { useUserStore } from "@/store";
import { Button } from "@/components/Button";
import Input from "@/components/Form/Input";
import Spinner from "@/components/Spinner";

import styles from "./Onboarding.module.css";

const signInFormScheme = yup.object({
  email: yup.string().email("Please enter a valid email address").required("Email is required"),
  password: yup.string().min(8, "Password must be at least 8 characters").required("Password is required")
});

export default function EmailAndPassword() {
  const { signIn, isSignInLoading } = useUserStore();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<yup.InferType<typeof signInFormScheme>>({
    resolver: yupResolver(signInFormScheme),
    defaultValues: {
      email: "",
      password: ""
    },
    mode: "onSubmit"
  });

  const onSubmit = (data: yup.InferType<typeof signInFormScheme>) => {
    signIn(data);
  };

  return (
    <OnboardingLayout currentStep={3} totalSteps={4}>
      <h2 className={styles.stepTitle}>Log In</h2>

      <form className={styles.inputFormContainer} onSubmit={handleSubmit(onSubmit)}>
        <Input error={errors["email"]} placeholder="E-mail" {...register("email")} type="email" />
        <Input error={errors["password"]} placeholder="Password" {...register("password")} type="password" />
        <Button type="submit" className={styles.emailBtn} disabled={isSignInLoading}>
          {!isSignInLoading ? <span className={styles.emailBtnText}>Login</span> : <Spinner />}
        </Button>
      </form>
      <button className={styles.skipLink} onClick={() => navigate("/onboarding")}>
        ← Go back
      </button>
    </OnboardingLayout>
  );
}
